import { render, staticRenderFns } from "./AnnualSPFTable.vue?vue&type=template&id=3f0665bf&"
import script from "./AnnualSPFTable.vue?vue&type=script&lang=js&"
export * from "./AnnualSPFTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports